module.exports = "<template> <table class=\"table table-condensed table-hover\"> <slot></slot> </table> </template>";